import * as HeaderStore from '@Stores/Header';
import useMedias from '@Hooks/useMedias';

import type { MutableRefObject } from 'react';

const useScrollToRef = () => {
  const { isOnlyMobile } = useMedias();
  const { totalHeight, contentHeight } = HeaderStore.useSizes();

  const handleScrollTo = (ref: MutableRefObject<HTMLDivElement>, correction = 0) => {
    if (!ref.current) return;

    const rect = ref.current.getBoundingClientRect();
    let top = window.scrollY + rect.top - correction;

    if (isOnlyMobile && window.scrollY > rect.top) {
      top -= totalHeight;
    } else if (!isOnlyMobile) {
      top -= contentHeight;
    }

    window.scrollTo({ top, behavior: 'smooth' });
  };

  return { handleScrollTo };
};

export default useScrollToRef;
